import { ListDocument } from 'api/user/uploadI9Document'
import { DocumentType, ListA, ListB, ListC, Supplementary } from './constants'

export const getListTypeFromDocumentType = (
  documentType: DocumentType
): ListDocument['listType'] => {
  // @ts-expect-error - Type cannot match readonly const
  if (ListA.includes(documentType)) return 'A'
  // @ts-expect-error - Type cannot match readonly const
  if (ListB.includes(documentType)) return 'B'
  // @ts-expect-error - Type cannot match readonly const
  if (ListC.includes(documentType)) return 'C'
  // @ts-expect-error - Type cannot match readonly const
  if (Supplementary.includes(documentType)) return 'Supplementary'

  throw new Error(`Invalid document type: ${documentType}`)
}

export const isListComplete = (
  documents: ListDocument[],
  isSupplementB = false
): boolean => {
  const hasListType = documents.reduce(
    (listTypes, document) => {
      listTypes[document.listType] = true
      return listTypes
    },
    {} as Record<ListDocument['listType'], boolean>
  )

  if (isSupplementB) {
    return (hasListType['A'] || hasListType['C']) && documents.length === 1
  }
  return hasListType['A'] || (hasListType['B'] && hasListType['C'])
}
